import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cf4c6d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "type" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { key: 0 }


import {Clock, User} from '@element-plus/icons'
import {CourseLivePlan, CourseLivePlanStatusEnums} from "@/models/live/courseLivePlan";
import {CoursePlanPartVO} from "@/apis/course";
import useDateConvert from "@/composables/useDateConvert";
import usePartConvert from "@/composables/usePartConvert";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLiveHeader',
  props: {
    part: {},
    live: {}
  },
  setup(__props: any) {

const props = __props

const {convertDatetime} = useDateConvert()
const {convertPartType} = usePartConvert()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(convertPartType)(_ctx.part)), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.part.partName), 1),
      _createElementVNode("span", {
        class: "status",
        style: _normalizeStyle({
            borderColor: _unref(CourseLivePlanStatusEnums)[_ctx.live.status]?.color,
            color: _unref(CourseLivePlanStatusEnums)[_ctx.live.status]?.color
          })
      }, _toDisplayString(_unref(CourseLivePlanStatusEnums)[_ctx.live.status]?.text), 5)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.live.status !== 'NORMAL')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createVNode(_unref(Clock), { class: "icon" }),
            _createTextVNode(" 直播时间：" + _toDisplayString(_unref(convertDatetime)(_ctx.live.openTime, "YYYY年MM月DD日 HH:mm:ss")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        _createVNode(_unref(User), { class: "icon" }),
        _createTextVNode(" 主讲老师：" + _toDisplayString(_ctx.live.teacher), 1)
      ])
    ])
  ]))
}
}

})